module.exports = global["jQuery"] = require("-!/home/galaxy/immport-galaxy/client/node_modules/expose-loader/index.js?$!./jquery.custom.js");